import React from 'react';
import AdSlot from 'components/ads/ad-slot';
import AdSlotSSR from 'components/ads/ad-slot-ssr';
import MainLayout from './main-layout.base';
import HeaderDesktop from '../header/header.desktop';
import FooterDesktop from '../footer/footer.desktop';
import Container from 'atomic/container';
import { Head } from '@ecommerce/nest-ssr/components';
import { SLOT_SPONSORING_TOP, SLOT_SCROLLER } from 'components/ads/ad-slot/ad-defs';
import TopBar from 'modules/shared/layout/top-bar';

import './main-layout.desktop.scss';

type MainLayoutDesktop = {
    children: React.ReactNode;
};

const MainLayoutDesktop: React.FC<MainLayoutDesktop> = ({ children }) => (
    <>
        <Head>
            <meta name="viewport" content="width=device-width" />
            <meta charSet="UTF-8" />
        </Head>
        <AdSlotSSR name={SLOT_SPONSORING_TOP} className="creation-topbar" resizable={true} />
        <HeaderDesktop />
        <TopBar />
        <MainLayout>
            {children}
        </MainLayout>
        <Container className="screening-bg">
            <FooterDesktop />
        </Container>
        <AdSlot name={SLOT_SCROLLER} className="creation-bottom" />
    </>
);

export default MainLayoutDesktop;
